import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';

import { loginUser } from '../../api/BackendApi'; 
import { AuthLayout, FormInput, FormButton } from '../../components/AuthComponents.jsx';

const LoginPage = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await loginUser({ email, password });
      if (onLoginSuccess) {
        await onLoginSuccess();
      }
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Přihlášení se nezdařilo. Zkontrolujte zadané údaje.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout title="Přihlaste se do svého účtu">
      <form className="space-y-6" onSubmit={handleSubmit}>
        {error && (
          <div className="p-3 text-sm text-red-700 bg-red-100 rounded-md">
            {error}
          </div>
        )}
        <FormInput
          id="email"
          label="Emailová adresa"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div>
          <label
            htmlFor="password"
            className="block text-sm font-medium text-gray-700"
          >
            Heslo
          </label>

          <div className="relative mt-1">
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />

            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
              aria-label={showPassword ? 'Skrýt heslo' : 'Zobrazit heslo'}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between text-sm">
            <Link
                to="/forgot-password"
                className="font-medium text-indigo-600 hover:text-indigo-500"
            >
                Zapomněli jste heslo?
            </Link>
        </div>

        <FormButton isLoading={isLoading}>Přihlásit se</FormButton>

        <p className="text-sm text-center text-gray-600">
            Ještě nemáte účet?{' '}
            <Link
                to="/register"
                className="font-medium text-indigo-600 hover:text-indigo-500"
            >
                Vytvořte ho zde
            </Link>
        </p>
      </form>
    </AuthLayout>
  );
};

export default LoginPage;
